import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  testStartDate: undefined,
  testStartSeconds: undefined,
  createdTest: { QuestionsForTest: [], FirstQuestion: {} },
  examToReview: undefined,
  testExtraSeconds: 0, //300 seconds = 5 mins
  testOutOfTime: false,
  whenTestRanOutOfTime: undefined, //used to make sure that the extra time is given from when the button was clicked
  //"Pause timer" in the settings bar. Kept in the store only (not saved), so a
  //new test never starts paused. timerPausedAt is when the current pause began.
  timerPaused: false,
  timerPausedAt: undefined,
};
const testSlice = createSlice({
  name: "test",
  initialState,
  reducers: {
    setTestStart(state, action) {
      state.testStartDate = action.payload.testStartDate;
    },
    setTestStartSeconds(state, action) {
      state.testStartSeconds = action.payload.testStartSeconds;
      state.testStartDate = action.payload.testStartDate;
    },
    setCreatedTest(state, action) {
      state.createdTest = action.payload.createdTest;
      //Reset extra seconds on created test
      state.testExtraSeconds = 0;
      state.testOutOfTime = false;
      state.whenTestRanOutOfTime = undefined;
      state.timerPaused = false;
      state.timerPausedAt = undefined;
    },
    setReviewedExam(state, action) {
      state.examToReview = action.payload.examToReview;
    },
    addTestExtraSeconds(state, action) {
      state.testExtraSeconds += action.payload.testExtraSeconds;
      state.testOutOfTime = false;
      state.whenTestRanOutOfTime = undefined;
    },
    setTestOutOfTime(state, action) {
      state.testOutOfTime = action.payload.testOutOfTime;
      state.whenTestRanOutOfTime = action.payload.whenTestRanOutOfTime;
    },
    //payload: { paused: boolean, at: number (Date.now() when toggled) }
    //Resuming adds the paused time to testExtraSeconds, so the deadline moves
    //back by exactly how long the timer was paused.
    setTimerPaused(state, action) {
      const { paused, at } = action.payload;
      if (paused === state.timerPaused) return;
      if (paused) {
        state.timerPaused = true;
        state.timerPausedAt = at;
      } else {
        if (state.timerPausedAt !== undefined) {
          state.testExtraSeconds +=
            Math.max(0, at - state.timerPausedAt) / 1000;
        }
        state.timerPaused = false;
        state.timerPausedAt = undefined;
      }
    },
  },
});

export const {
  setTestStart,
  setCreatedTest,
  setTestStartSeconds,
  setReviewedExam,
  addTestExtraSeconds,
  setTestOutOfTime,
  setTimerPaused,
} = testSlice.actions;
export default testSlice.reducer;
export const getTestStartSelector = (state) => state.test.testStartDate;
export const getTestStartSecondsSelector = (state) =>
  state.test.testStartSeconds;
export const getCreatedTest = (state) => state.test.createdTest;
export const getExamToReview = (state) => state.test.examToReview;
export const getTestExtraSeconds = (state) => state.test.testExtraSeconds;
export const getTestOutOfTime = (state) => state.test.testOutOfTime;
export const getWhenTestRanOutOfTime = (state) =>
  state.test.whenTestRanOutOfTime;
export const getTimerPaused = (state) => state.test.timerPaused;
